<template>
  <section class="about-us-banner">
    <MainBanner :heading="heading" :desc="desc" />

  </section>
</template>

<script setup>
import MainBanner from "../Global/MainBanner.vue";
const heading = "Our Services";
const desc = "When it comes to plumbing and heating services, we pride ourselves on providing the best solutions for your needs. Our comprehensive range of services covers various areas, such as commercial restaurant and home plumbing services, legal basement contractors, radiant floor heating, bathroom renovations, trenchless water service installation, water service upgrades, drain and sewer replacement, installation, camera inspection, and fire sprinkler installation around the GTA region.";
</script>

<style scoped>
.about-us-banner {
  background-image: linear-gradient(to right, rgba(0, 29, 51, 0.8), rgba(90, 99, 105, 0.8)), url("../../assets/v-1.1/Banners/services-banner.png");
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 5.5rem;
}
</style>